import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

const FooterMenusWidgets = ({}) => {
  const { contentfulWebsiteFooter } = useStaticQuery(graphql`
    {
      contentfulWebsiteFooter(
        id: { eq: "f261f178-6b6a-59e3-8e7b-95a6d79646e2" }
      ) {
        id
        footerLogo {
          gatsbyImage(width: 300, quality: 70, placeholder: NONE)
        }
        ageLogo {
          gatsbyImage(width: 150, quality: 70, placeholder: NONE)
        }
        linkDescription
        footerLink {
          linkRoute
          linkText
          linkType
        }
        title
        description
      }
    }
  `);

  const image = getImage(contentfulWebsiteFooter.footerLogo);
  const ageImage = getImage(contentfulWebsiteFooter.ageLogo);
  return (
    <div className="footer-nav-widgets-wrapper header-footer-group">
      <div className="footer-inner section-inner">
        <aside className="footer-widgets-outer-wrapper" role="complementary">
          <div className="footer-widgets-wrapper">
            <div className="footer-widgets column-one grid-item">
              <GatsbyImage image={image} alt="Ontario" />
            </div>
            <div className="footer-widgets column-two grid-item">
              <div className="widget widget_text">
                <h3>{contentfulWebsiteFooter?.title}</h3>
                <p>{contentfulWebsiteFooter?.description}</p>
                <p>
                  {contentfulWebsiteFooter?.linkDescription} - &nbsp;
                  <a
                    href={contentfulWebsiteFooter?.footerLink?.linkRoute}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {contentfulWebsiteFooter?.footerLink?.linkText}
                  </a>
                </p>
                <GatsbyImage image={ageImage} alt="19+" />
              </div>
            </div>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default FooterMenusWidgets;
